import App from './App';
import { SettingsProvider, restoreSettings } from './contexts/SettingsContext';
import './translations';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <SettingsProvider settings={restoreSettings()}>
    <App />
  </SettingsProvider>
);
